import {VariationsBody} from '@intellimize/dash-shared';
import {Selector} from './_internal-shared-types';
import {DomChangeType} from '@intellimize/customer';
import {DesignerStores} from '@packages/systems/designer/flux';
import {DATA_EXPLORER_PANEL} from '@packages/systems/designer/panels';
import {getActivePanelName} from '@packages/systems/panels';

export const selectSiteShortName: Selector<string> = (state) =>
  state.SiteDataStore.shortName;

export const selectSiteId: Selector<string> = (state) =>
  state.SiteDataStore.siteId;

export const selectCustomerId: Selector<string | null> = (state) =>
  state.OptimizationStore.customerId;

export const selectPreferredUrl: Selector<string> = (state) =>
  state.SiteDataStore.preferredUrl;

export const selectSiteSubdomain: Selector<string> = (state) => {
  return state.PublishDropdownUIStore.domains.first().name;
};

export const selectEntitlementsHaveLoaded: Selector<boolean> = (state) =>
  !state.EntitlementsStore.isLoading &&
  Boolean(state.EntitlementsStore.entitlements);

export const selectIsInDataExplorer = (state: DesignerStores) =>
  getActivePanelName(state.PanelsStore, 'left') === DATA_EXPLORER_PANEL;

export const getAPIProxyPath = (siteShortName: string) => {
  // Both preview and regular routes now use the same path structure
  // The difference is in the vHost (preview.webflow.com vs webflow.com)
  // which is handled by setting baseURL in the fetch calls
  return `/api/sites/${siteShortName}/intellimize` as const;
};

export const DEFAULT_BASE_VARIATION: VariationsBody = {
  name: 'Base variation',
  state: 'draft',
  preconditions: [],
};

export const DEFAULT_TREATMENT_VARIATION: VariationsBody = {
  name: 'Variation 1',
  state: 'draft',
  changes: [{type: DomChangeType.WEBFLOW}],
  preconditions: [],
};
